class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    // TDW: personalizzazione del negozio. Se la risposta di un'aggiunta ha gia'
    // riempito il drawer, rileggerlo ricreerebbe <cart-items> sotto una modifica
    // che il cliente puo' aver appena avviato, e il numero sull'icona restava
    // quello vecchio.
    if (this.querySelector('form.mini-cart')) {
      document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      return;
    }

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        // riempito nel frattempo da un'aggiunta: quella risposta e' piu' recente
        const sectionHTML = this.querySelector('form.mini-cart') ? undefined : this.getSectionInnerHTML(html, '.shopify-section');
        if (sectionHTML !== undefined) document.getElementById('mini-cart').innerHTML = sectionHTML;

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    // TDW: durante i 400ms dell'animazione di chiusura il drawer ha ancora
    // [open]: un'aggiunta che arriva in quel momento lo riapre a chiusura finita.
    if (detailsElement.classList.contains('menu-closing')) {
      clearTimeout(this.reopenTimer);
      this.reopenTimer = setTimeout(() => this.open(), 450);
      return;
    }
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  // TDW: { open: false } per le azioni fatte dentro il drawer (suggeriti,
  // confezione regalo): se intanto il cliente lo ha chiuso, non va riaperto.
  renderContents(parsedState, { open = true } = {}) {
    this.productId = parsedState && parsedState.id;
    // TDW: questa risposta ridisegna il carrello (vedi theme.cartWriteSeq in cart.js)
    if (window.theme) theme.cartWriteSeq = (theme.cartWriteSeq || 0) + 1;

    // While the drawer is open (upsell adds, gift wrap, quick view),
    // patch the money-touched regions instead of swapping the whole
    // drawer — keeps open collapsibles, scroll and upsell state intact.
    const drawerOpen = this.drawer && !!this.drawer.querySelector('details[open]');

    // TDW: Shopify restituisce null per una sezione che non riesce a generare
    // (e un'app puo' restituire una risposta senza sezioni). Prima l'errore
    // fermava tutto prima di open(): drawer chiuso e numero non aggiornato.
    // Ora la parte mancante resta com'e', si rilegge a parte e il drawer si apre.
    const sections = (parsedState && parsedState.sections) || {};
    let missing = false;

    this.getSectionsToRender().forEach((section => {
      const element = document.getElementById(section.id);
      if (!element) return;

      const sectionHTML = sections[section.id] ? this.getSectionInnerHTML(sections[section.id], section.selector) : undefined;
      if (sectionHTML === undefined) {
        missing = true;
        return;
      }

      if (
        section.id === 'mini-cart' &&
        drawerOpen &&
        window.theme && theme.patchMiniCart &&
        theme.patchMiniCart(sectionHTML)
      ) return;

      element.innerHTML = sectionHTML;
    }));

    // Una sezione mancante si rilegge a parte. Con una modifica di quantita'
    // ancora in corso la sua risposta, piu' vecchia di questa, potrebbe
    // arrivare dopo: in quel caso si rilegge tutto quando sara' finita.
    if ((missing || (window.theme && theme.cartPending > 0)) && window.theme && theme.resyncCart) theme.resyncCart({ drawer: true });

    if (open) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
